import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import {
  CreateGainFormulaTemplateRequest,
  CreateGainFormulaTemplateTypeRequest,
  GainFormulaTemplate,
  GainFormulaTemplateType,
  GainFormulaTemplateTypeDeletionImpact,
  UpdateGainFormulaTemplateRequest,
  UpdateGainFormulaTemplateTypeRequest,
} from '../models/gain-formula-template.model';

@Injectable({
  providedIn: 'root',
})
export class GainFormulaTemplateService {
  constructor(private apiService: ApiService) {}

  getTypes(): Observable<GainFormulaTemplateType[]> {
    return this.apiService.get<GainFormulaTemplateType[]>(
      '/GainFormulaTemplateType/GetAll/',
    );
  }

  getTypeDeletionImpact(
    uid: string,
  ): Observable<GainFormulaTemplateTypeDeletionImpact> {
    return this.apiService.get<GainFormulaTemplateTypeDeletionImpact>(
      `/GainFormulaTemplateType/GetDeletionImpact/${encodeURIComponent(uid)}`,
    );
  }

  createType(
    request: CreateGainFormulaTemplateTypeRequest,
  ): Observable<GainFormulaTemplateType> {
    return this.apiService.post<GainFormulaTemplateType>(
      '/GainFormulaTemplateType/Create/',
      request,
    );
  }

  updateType(
    request: UpdateGainFormulaTemplateTypeRequest,
  ): Observable<GainFormulaTemplateType> {
    return this.apiService.put<GainFormulaTemplateType>(
      '/GainFormulaTemplateType/Update/',
      request,
    );
  }

  deleteType(uid: string): Observable<void> {
    return this.apiService.delete<void>(
      `/GainFormulaTemplateType/${encodeURIComponent(uid)}`,
    );
  }

  getTemplates(includeDeleted: boolean): Observable<GainFormulaTemplate[]> {
    return this.apiService.get<GainFormulaTemplate[]>(
      '/GainFormulaTemplate/GetAll/',
      { queryParams: { includeDeleted: String(includeDeleted) } },
    );
  }

  getVersions(groupId: string): Observable<GainFormulaTemplate[]> {
    return this.apiService.get<GainFormulaTemplate[]>(
      `/GainFormulaTemplate/GetVersions/${encodeURIComponent(groupId)}`,
    );
  }

  createTemplate(
    request: CreateGainFormulaTemplateRequest,
  ): Observable<GainFormulaTemplate> {
    return this.apiService.post<GainFormulaTemplate>(
      '/GainFormulaTemplate/Create/',
      request,
    );
  }

  updateTemplate(
    request: UpdateGainFormulaTemplateRequest,
  ): Observable<GainFormulaTemplate> {
    return this.apiService.put<GainFormulaTemplate>(
      '/GainFormulaTemplate/Update/',
      request,
    );
  }

  deleteTemplate(groupId: string): Observable<void> {
    return this.apiService.delete<void>(
      `/GainFormulaTemplate/${encodeURIComponent(groupId)}`,
    );
  }
}
